export const TAX_WITHHOLDING_EXEMPTION_LABEL = 'Exclude from tax withholding';
export const TAX_WITHHOLDING_EXEMPTION_ICON = 'fas fa-hand-holding-usd';
export const TAX_WITHHOLDING_EXEMPTION_TEST_ID = 'toggle-tax-withholding-exemption';
export const TAX_WITHHOLDING_EXEMPT_COLOR = '#28A745';
export const TAX_WITHHOLDING_EXEMPTION_SAVE_ERROR = 'The tax withholding change could not be saved.';

export const taxWithholdingExemptionTooltip = (exempt) => (
  exempt
    ? 'Not withheld: paid to the artist in full and left out of tax withholding. Click to withhold on it again.'
    : 'Exclude from tax withholding. The artist is still paid this amount, but it is not withheld on.'
);

export const offerWithholdsTax = (offer) => (
  !!offer?.has_tax_withholding
    || (offer?.pool_members || []).some((member) => !!member.has_tax_withholding)
);

const exemptionRelevant = (row, offer) => (
  offerWithholdsTax(offer) || !!row.exempt_from_tax_withholding
);

export const canToggleTaxWithholdingExemption = (budgetLineItem, offer) => (
  !!offer && budgetLineItem.category === 'ADDITION' && exemptionRelevant(budgetLineItem, offer)
);

export const canToggleSettlementLineItemExemption = (item, sectionTitle, offer) => (
  sectionTitle === 'Additions'
    && item.overridable_type === 'SettlementLineItem'
    && exemptionRelevant(item, offer)
);

export const showsNotWithheld = (item, sectionTitle, offer) => (
  sectionTitle === 'Additions'
    && !!item.exempt_from_tax_withholding
    && Number(item.calculatedTotal) > 0
    && offerWithholdsTax(offer)
);
